import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=0da66341&scoped=true"
import script from "./addQuestion.vue?vue&type=script&lang=js"
export * from "./addQuestion.vue?vue&type=script&lang=js"
import style0 from "./addQuestion.vue?vue&type=style&index=0&id=0da66341&prod&lang=less&scoped=true"
import style1 from "./addQuestion.vue?vue&type=style&index=1&id=0da66341&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da66341",
  null
  
)

export default component.exports